// extracted by mini-css-extract-plugin
module.exports = {"scalable-inner":"scalable-inner___1-VtO","scalableInner":"scalable-inner___1-VtO","scalable":"scalable___2cXWi"};